import { CirclePlusIcon } from 'lucide-react';

import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  HelperText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/_components';
import { ActionButton, ActionButtonContainer, FormLayout } from '@/_containers';
import { stopPropagate } from '@/_shared';

import { CreateSKU } from './create';
import { UpdateSKUItem } from './update-sku-item';
import type { EditProps } from './use-edit';
import { useEdit } from './use-edit';

export function EditSKUs(props: EditProps) {
  const { open, form, isLoading, createProps, onClose, onSubmit, onAdd, handleUpdateSKUItem } = useEdit(props);

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableBackdropClosing
      disableInternalClosing={form.formState.isSubmitting || isLoading}
    >
      <Form {...form}>
        {({ handleSubmit }) => (
          <form onSubmit={stopPropagate(handleSubmit(onSubmit))}>
            <ModalHeader>Edit Secondary SKUs</ModalHeader>
            <ModalBody>
              <FormLayout className="gap-y-4">
                <CreateSKU {...createProps}>
                  <ActionButtonContainer>
                    <ActionButton title="Add new SKU" icon={CirclePlusIcon} onClick={onAdd} />
                  </ActionButtonContainer>
                </CreateSKU>

                <FormField
                  control={form.control}
                  name="skus"
                  render={({ field }) => (
                    <>
                      {field?.value?.map((item, i) => {
                        return (
                          <FormField
                            control={form.control}
                            key={item.id}
                            name={`skus.${i}`}
                            render={() => (
                              <FormItem className="col-span-12" key={item.id}>
                                <FormControl>
                                  <UpdateSKUItem value={item} onChange={handleUpdateSKUItem} />
                                </FormControl>
                                <FormMessage className="-mt-8" id="sku" />
                              </FormItem>
                            )}
                          />
                        );
                      })}
                      {form.formState.errors.skus?.message && (
                        <HelperText className={'text-error col-span-12 -mt-4 text-xs'}>
                          {form.formState.errors.skus?.message}
                        </HelperText>
                      )}
                    </>
                  )}
                />
              </FormLayout>
            </ModalBody>
            <ModalFooter className="mt-6">
              <Button
                modal
                type="submit"
                disabled={!(form.formState.isDirty || createProps.form.formState.isDirty)}
                showLoader={form.formState.isSubmitting || isLoading}
              >
                Done
              </Button>
            </ModalFooter>
          </form>
        )}
      </Form>
    </Modal>
  );
}
